/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import * as MaterialIcons from '@material-ui/icons'
import ElderlyIcon from '@mui/icons-material/Elderly'
import KeyIcon from '@mui/icons-material/Key'
import AddReactionIcon from '@mui/icons-material/AddReaction'
import HomeIcon from '@mui/icons-material/Home'
import PsychologyAlt from '@mui/icons-material/PsychologyAlt'
import  MarkChatUnread from '@mui/icons-material/MarkChatUnread'
import  Apps from '@mui/icons-material/Apps'
import {useMenuContext} from '../../../../app/pages/contexts/MenuContext'

const menuicn: any = {
  Dashboard: MaterialIcons.Dashboard,
  Home: HomeIcon,
  Assignment: MaterialIcons.Assignment,
  key: KeyIcon,
  AddReaction: AddReactionIcon,
  Elderly: ElderlyIcon,
  EnhancedEncryption: MaterialIcons.EnhancedEncryption,
  PsychologyAlt: PsychologyAlt,
  ContactSupport: MaterialIcons.ContactSupport,
  MarkChatUnread: MarkChatUnread,
  Apps: Apps,
}
const AsideMenuMain = () => {
  const {fullMenu} = useMenuContext()
  
  
  return (
    <>
    
    {/* removed container */}
      {/* <ToastContainer /> */}
      {fullMenu &&
        fullMenu.map((item: any) => {
          return (
            <>
              {item['submenu'].length <= 0 ? (
                <AsideMenuItem
                  key={item.itemId}
                  to={String(item.path)}
                  icon={menuicn[item.icon]}
                  title={item.name}
                  supportCount={item.supportCount}
                  reviewCount={item.reviewCount}
                  menuId={item.menuId}
                  fontIcon='bi-app-indicator'
                  hasMain=''
                />
              ) : (
                <AsideMenuItemWithSub to='' title={item.name} icon={menuicn[item.icon]} supportCount={item.supportCount} reviewCount={item.reviewCount} >
                  {item.submenu.map((submenu: any) => {
                    return (
                      <>
                        {submenu['submenu'].length <= 0 ? (
                          <AsideMenuItem
                            to={String(submenu.path != null ? submenu.path.trim() : '')}
                            title={submenu.name}
                            hasBullet={true}
                            hasMain={item.name}
                            menuId={submenu.menuId}
                            supportCount={submenu.supportCount}
                            reviewCount={submenu.reviewCount}
                          />
                        ) : (
                          <AsideMenuItemWithSub
                            to=''
                            title={submenu.name}
                            icon={menuicn[item.icon]}
                            supportCount={submenu.supportCount}
                            reviewCount={submenu.reviewCount}
                          >
                            {submenu['submenu'] &&
                              submenu['submenu'].map((subsubmenu: any) => {
                                return (
                                  <AsideMenuItem
                                    to={String(
                                      subsubmenu.path != null ? subsubmenu.path.trim() : ''
                                    )}
                                    title={subsubmenu.name}
                                    hasBullet={true}
                                    hasMain={submenu.name}
                                    menuId={subsubmenu.menuId}
                                    supportCount={subsubmenu.supportCount}
                                    reviewCount={subsubmenu.reviewCount}
                                  />
                                )
                              })}
                          </AsideMenuItemWithSub>
                        )}
                      </>
                    )
                  })}
                </AsideMenuItemWithSub>
              )}
            </>
          )
        })}
    </>
  )
}

export {AsideMenuMain}
